export const hotlist = [
  "VEH186803",
  "VEH179894",
  "VEH186808",
  "VEH177733",
  "VEH177719",
  "VEH177722",
  "VEH177727",
  "VEH177726",
  "VEH177736",
  "VEH177739",
  "VEH185325",
  "VEH185323",
  "VEH185319",
  "VEH185326",
  "VEH184913",
  "VEH185748",
  "VEH185863",
  "VEH186946",
  "VEH186947",
  "VEH186942",
  "VEH185750",
  "VEH186937",
  "VEH186959",
  "VEH186088",
  "VEH183778",
  "VEH181445",
  "VEH182227",
  "VEH185683",
  "VEH185674",
  "VEH185675",
  "VEH185676",
  "VEH185677",
  "VEH185679",
  "VEH181544",
  "VEH183774",
  "VEH183677",
  "VEH183696",
  "VEH183777",
  "VEH183760",
  "VEH183771",
  "VEH183778",
  "VEH183738",
  "VEH183734",
  "VEH183736",
  "VEH183762",
  "VEH183763",
  "VEH183733",
  "VEH183764",
  "VEH183766",
  "VEH183768",
  "VEH183769",
];
